var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherRegionsIconMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1776 10.6385L10.6946 17.0906L12.1054 18.5082L20.3054 10.3473L21.0176 9.63852L20.3054 8.92973L12.1054 0.768869L10.6946 2.18646L17.1776 8.63852L-3.24249e-05 8.63852V10.6385L17.1776 10.6385Z"
  })));
}
export default SvgOtherRegionsIconMore;